export default "/images/external-link.svg?90577cce48ecfddde9064420d52d9f5f";